<!--
	个人资料
	lovi 2020-1-3
-->
<template>
  <div>
    <div class="breadcrumb-wrap">
      <Breadcrumb separator=">">
        <BreadcrumbItem to="/">{{ $t("common.eepay") }}</BreadcrumbItem>
        <BreadcrumbItem>{{
          $t("personal.personalInformation")
        }}</BreadcrumbItem>
      </Breadcrumb>
    </div>
    <div class="list-wrap">
      <div class="item-list">
        <h3>{{ $t("personal.avatar") }}</h3>
        <div class="info">
          <div class="info-l">
            <div class="portrait">
              <div class="upload" v-if="portraitFlag">
                {{ $t("personal.uploadAvatar") }}
                <input
                  type="file"
                  ref="portraitUpload"
                  @change="uploadPortrait"
                />
              </div>
              <img v-if="avatarImg" :src="avatarImg" />
              <img
                v-else-if="userInfo.avatar"
                :src="httpUrl + userInfo.avatar"
                @error="emptyPortrait"
              />
              <img v-else src="@/assets/images/public/default_avatar@2x.png" />
            </div>
          </div>
          <a
            v-if="portraitFlag"
            href="javascript:void(0)"
            @click="confirm('portrait')"
          >
            {{ $t("common.confirm") }}
          </a>
          <a v-else href="javascript:void(0)" @click="modify('portrait')">
            {{ $t("personal.modify") }}
          </a>
          <!-- <a href="javascript:void(0)" @click="userPortrait">修改</a> -->
        </div>
      </div>
      <div class="item-list">
        <h3>{{ $t("personal.nickname") }}</h3>
        <div class="info">
          <div class="info-l">
            <Form
              ref="refNickname"
              :model="formNickname"
              :rules="ruleNickname"
              :label-width="0"
              label-position="right"
            >
              <FormItem prop="nickname">
                <Input
                  type="text"
                  v-model="formNickname.nickname"
                  :disabled="!nicknameFlag"
                  placeholder=""
                />
              </FormItem>
            </Form>
          </div>
          <a
            v-if="nicknameFlag"
            href="javascript:void(0)"
            @click="confirm('nickname')"
          >
            {{ $t("common.confirm") }}
          </a>
          <a v-else href="javascript:void(0)" @click="modify('nickname')">
            {{ $t("personal.modify") }}
          </a>
        </div>
      </div>
      <div class="item-list">
        <h3>{{ $t("common.mobileNumber") }}</h3>
        <div class="info">
          <div class="info-l">
            <Input
              type="text"
              v-model="userInfo.phone"
              readonly
              placeholder=""
            />
          </div>
        </div>
      </div>
      <div class="item-list">
        <h3>{{ $t("personal.eepayAccount") }}</h3>
        <div class="info">
          <div class="info-l">
            <Input
              type="text"
              v-model="userInfo.username"
              readonly
              placeholder=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as validate from "@/commonJs/validate";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "personal-userInfo",
  data() {
    return {
      avatarImg: "",
      portraitFlag: false, //修改头像
      nicknameFlag: false, //修改昵称

      formNickname: {
        nickname: this.$t("common.notSet")
      },
      ruleNickname: {
        nickname: [
          {
            trigger: "blur",
            validator: validate.validateNickname
          }
        ]
      }
    };
  },
  created() {},
  mounted() {},
  computed: {
    ...mapGetters(["userInfo"])
  },
  methods: {
    ...mapActions(["GET_USER_INFO"]),
    emptyPortrait() {
      // 清空头像路径
      this.userInfo.portrait = "";
    },
    uploadPortrait() {
      //上传头像
      let vm = this;
      let maxSize = 4;
      let upload = vm.$refs.portraitUpload;
      var file = upload.files[0]; //获取上传文件列表中第一个文件
      if (!/\.(?:JPG|GIF|PNG|JPEG|BMP)$/i.test(file.name)) {
        //仅支持JPG、GIF、PNG、JPEG、BMP格式
        // alert("文件必须为图片！");
        vm.$Message.error(vm.$t("personal.onlySupportsFormat"));
        return false;
      }
      if (file.size > maxSize * 1024 * 1024) {
        vm.$Message.error(vm.$t("personal.picSizeTips") + maxSize + "M");
        return false;
      }
      // var reader = new FileReader();//实例一个文件对象
      // reader.readAsDataURL(file);//把上传的文件转换成url

      //当文件读取成功便可以调取上传的接口
      var image = new Image();
      // 设置src属性
      image.src = vm.getObjectURL(file);
      // 绑定load事件处理器，加载完成后执行，避免同步问题
      image.onload = function() {
        vm.avatarImg = vm.getBase64Image(image);
      };
    },
    getObjectURL(file) {
      var url = null;
      if (window.createObjectURL != undefined) {
        // basic
        url = window.createObjectURL(file);
      } else if (window.URL != undefined) {
        // mozilla(firefox)
        url = window.URL.createObjectURL(file);
      } else if (window.webkitURL != undefined) {
        // webkit or chrome
        url = window.webkitURL.createObjectURL(file);
      }
      return url;
    },
    getBase64Image(img) {
      var canvas = document.createElement("canvas");
      canvas.width = 150;
      canvas.height = 150;
      var ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, 150, 150);
      var ext = img.src.substring(img.src.lastIndexOf(".") + 1).toLowerCase();
      var dataURL = canvas.toDataURL("image/" + ext);
      return dataURL;
    },
    modify(flag) {
      // 修改
      let vm = this;
      if (flag == "portrait") {
        vm.portraitFlag = true;
      }
      if (flag == "nickname") {
        vm.nicknameFlag = true;
      }
    },
    confirm(flag) {
      // 确定
      let vm = this;
      if (flag == "portrait") {
        if (vm.avatarImg == "") {
          vm.$Message.error(vm.$t("personal.selectAvatar"));
          return;
        }
        // vm.avatarImg.split(",")[1]
        vm.$post(
          "/app/user/avatarUpload",
          { avatar: vm.avatarImg.split(",")[1] },
          { loading: true }
        ).then(res => {
          console.log("avatarUpload", res);
          vm.portraitFlag = false;
          vm.avatarImg == "";
          vm.$store.dispatch("GET_USER_INFO");
        });
      }
      if (flag == "nickname") {
        let vm = this;
        vm.$refs.refNickname.validate().then(valid => {
          if (valid) {
            vm.$post(
              "/app/user/nicknameUpdate",
              { nickname: vm.formNickname.nickname },
              { loading: true }
            ).then(res => {
              console.log("nicknameUpdate", res);
              vm.nicknameFlag = false;
              vm.$store.dispatch("GET_USER_INFO");
            });
          } else {
            vm.$Message.error(vm.$t("verify.nicknameMsg"));
          }
        });
      }
    }
  },
  watch: {
    userInfo: {
      handler(obj) {
        if (obj.nickname) {
          this.formNickname.nickname = JSON.parse(JSON.stringify(obj.nickname));
        }
      },
      immediate: true
    }
  },
  components: {},
  deactivated() {},
  beforeDestroy() {}
};
</script>

<style lang="less" scoped>
.list-wrap {
  padding: 30px 50px;
  .item-list {
    padding: 24px 0;
    border-bottom: 1px solid #ccc;
    h3 {
      margin-bottom: 5px;
      font-size: 18px;
      font-weight: 500;
      line-height: 1.5;
    }
    .info {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 14px;
      /deep/.ivu-form-item {
        margin-bottom: 0;
      }
      /deep/.ivu-input {
        font-size: 14px;
        line-height: 24px;
        color: #2042ab;
        &[disabled],
        &[readonly] {
          cursor: text;
          padding-left: 0;
          padding-right: 0;
          background: #fff;
          border-color: #fff;
          box-shadow: none;
        }
        &[disabled] {
          color: #2042ab;
        }
        &[readonly] {
          color: #4a4a4a;
        }
      }
      .portrait {
        position: relative;
        width: 60px;
        height: 60px;
        border-radius: 50%;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
        }
        .upload,
        .upload input {
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }
        .upload {
          line-height: 60px;
          color: #fff;
          font-size: 12px;
          text-align: center;
          background: rgba(0, 0, 0, 0.5);
          input {
            opacity: 0;
            z-index: 1;
          }
        }
      }
    }
  }
}
</style>
